const registerGoogleMap = () => {
	// Declare map
	const googleMap = document.querySelectorAll('#map');

	// Google Maps
	googleMap.forEach((element) => {
		function createMap(el, lat, long, zoom, marker) {
			// Set a center point of the map, can be re-evaluated using `centerMap()`
			const center = { lat: lat, lng: long };

			const mapOptions = {
				zoom: zoom,
				center: center,
				fullscreenControl: false,
			};

			// Create a map instance.
			const melonMap = new MelonMap(document.getElementById(el), mapOptions);

			// Marker locations [name, lat, long, zindex]
			const markerLocation = [['Lomas Steel', lat, long, 1]];

			if (marker == true) {
				markerLocation.forEach((markerLocation) => {
					const title = markerLocation[0];

					const location = {
						lat: parseFloat(markerLocation[1]),
						lng: parseFloat(markerLocation[2]),
					}

					melonMap.addMarker(location, title);
				});
			}
		}

		// Initiate google map for contact form
		createMap('map', 51.77251234957216, -0.25041473083267596, 8, true);
	});
}

// Identify the device as touch device
function hasTouch() {
	return 'ontouchstart' in document.documentElement
		|| navigator.maxTouchPoints > 0
		|| navigator.msMaxTouchPoints > 0;
}

// Hack to remove all hover effects on touch devices
if (hasTouch()) { // remove all :hover stylesheets
	try { // prevent exception on browsers not supporting DOM styleSheets properly
		for (var si in document.styleSheets) {
			var styleSheet = document.styleSheets[si];
			if (!styleSheet.rules) continue;

			for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
				if (!styleSheet.rules[ri].selectorText) continue;

				if (styleSheet.rules[ri].selectorText.match('btn:hover')) {
					styleSheet.deleteRule(ri);
				}
			}
		}
	} catch (ex) { }
}

document.addEventListener('DOMContentLoaded', () => {
	registerGoogleMap();

	const body = document.querySelector('body');

	// Helper function
	let domReady = (cb) => {
		document.readyState === 'interactive' || document.readyState === 'complete'
			? cb()
			: document.addEventListener('DOMContentLoaded', cb);
	};

	domReady(() => {
		// Display body when DOM is loaded
		body.style.visibility = 'visible';
	});

	// Google Recaptcha v3
	grecaptcha.ready(function () {
		document.querySelectorAll('form.mod-recaptcha').forEach((element) => {
			// TODO: replace key with project one - this one is a Codename framework key
			grecaptcha.execute('6Le3scIZAAAAAOT2o50REZN2_JuOFanbYKkUz-de', { action: 'submit' }).then(function (token) {
				$('<input>').attr({
					type: 'hidden',
					name: 'g-recaptcha-response',
					value: token
				}).appendTo(element)
			});
		});
	});

	// hide cookie policy
	document.querySelector('.section-cookies .btn-accept').addEventListener('click', (e) => {
		e.preventDefault();

		// If no validation errors
		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 1,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	document.querySelector('.section-cookies .btn-decline').addEventListener('click', (e) => {
		e.preventDefault();

		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 0,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	// Add class to inputs when clicked on add effect
	const form = document.querySelectorAll('form');

	if (form) {
		document.querySelectorAll('form input, form textarea').forEach((element) => {
			element.addEventListener('focus', () => {
				element.parentElement.classList.add('mod-filled');
			});

			element.addEventListener('blur', () => {
				if (element.value) {
					element.parentElement.classList.add('mod-filled');
				} else {
					element.parentElement.classList.remove('mod-filled');
				}
			});
		});
	}

	const contactPage = document.querySelectorAll('#contact'),
		contactForm = document.querySelector('#contactForm');

	if (contactPage) {

		if (contactForm) {
			// Ajax contact form processing
			contactForm.addEventListener('submit', function (event) {
				event.preventDefault();

				const spamField = document.querySelectorAll('input#Form_Email'),
					loadingSpinner = document.querySelectorAll('.section-form .loading');

				// if honeypot field is filled in by spambot, do not submit
				if (spamField[0].value) {
					return false;
				}

				loadingSpinner[0].classList.add('mod-show');

				$.ajax({
					method: 'POST',
					url: 'process/contact/',
					dataType: 'json',
					data: $(this).serialize()
				}).done(function (response) {

					// If no errors
					if (response == 'success') {
						loadingSpinner[0].classList.remove('mod-show');

						// Remove filled class on inputs
						document.querySelectorAll('#contactForm .form-element').forEach((element) => {
							element.classList.remove('mod-filled');
						});

						// Hide form temporarily
						contactForm.classList.add('mod-hide');

						// Show thank you message
						contactForm.nextElementSibling.classList.add('mod-show');

						// Remove any errors that may still be there
						contactForm.firstElementChild.innerHTML = '';

						// Remove any values in inputs that would be still in there after submission
						document.querySelectorAll('#contactForm .form-element input, #contactForm .form-element textarea').forEach((element) => {
							element.value = '';
						});

						// Empty all error texts
						document.querySelectorAll('#contact .sub-error').forEach((element) => {
							element.innerHTML = '';
						});

						// Remove error class
						document.querySelectorAll('#contactForm .form-element').forEach((element) => {
							element.classList.remove('mod-error');
						});

						// Hide thank you message after 10 seconds and return to form
						setTimeout(function () {
							contactForm.classList.remove('mod-hide');
							contactForm.nextElementSibling.classList.remove('mod-show');
						}, 10000);

					}
					else {
						loadingSpinner[0].classList.remove('mod-show');

						contactForm.firstElementChild.innerHTML = 'Please fix the errors below:';

						// Empty any error messages that don't need it
						document.querySelectorAll('#contactForm .sub-error').forEach((element) => {
							element.innerHTML = '';
						});

						// Remove error class
						document.querySelectorAll('#contactForm .form-element').forEach((element) => {
							element.classList.remove('mod-error');
						});

						for (const [key, value] of Object.entries(response)) {
							if (key) {
								// Implement error message to specific input that needs it
								document.querySelectorAll('#contactForm .sub-error[data-error="' + key + '"]')[0].innerHTML = response[key]['message'];

								// Add error class to form element for styling
								if (key !== 'recaptcha') {
									document.querySelectorAll('#contactForm .form-element.mod-' + key)[0].classList.add('mod-error');
								}
							}
						}
					}
				});
			});
		}
	}

	// Hamburger menu function
	document.querySelectorAll('.mob-hamburger').forEach((hamburger) => {
		hamburger.addEventListener('click', (e) => {
			e.preventDefault();

			// Add active class to hamburger so it can be animated
			hamburger.classList.toggle('mod-active');

			hamburger.setAttribute('aria-label', 'Close menu');

			// Add active class to nav to show
			document.querySelector('#nav').classList.toggle('mod-show');

			// Add no scroll class to body to prevent scrolling when nav is active
			body.classList.toggle('no-scroll');

			// Add active class to header
			document.querySelector('.header-main').classList.toggle('mod-active');

			// Add active class on all li's
			if (!hamburger.classList.contains('mod-active')) {
				hamburger.setAttribute('aria-label', 'Open menu');

				document.querySelectorAll('#nav ul li').forEach((element) => {
					element.classList.remove('mod-show');
				});

				setTimeout(function () {
					document.querySelector('#nav').classList.remove('mod-show');
				}, 550);
			} else {
				setTimeout(function () {
					document.querySelectorAll('#nav ul li').forEach((element) => {
						element.classList.add('mod-show');
					});
				}, 900);
			}
		});
	});

	// Sub menu - mobile

	document.querySelectorAll('nav .list-nav li.mod-sub-nav.mod-mobile > a').forEach((dropdown) => {
		dropdown.addEventListener('click', (e) => {
			e.preventDefault();

			dropdown.classList.toggle('mod-active');
		});
	});

	// Ensure the function exists on the page before we call it.
	if (!!window['gdprSubscribeModal']) {
		// The form of which to attach the modal to.
		const formSelector = '#contact-form';
		// The url to link to for the privacy policy.
		const privacyPolicyURL = 'privacy-policy.html';
		// Color of the links in the modal
		const linkColour = '#000';
		// Color of the buttons in the modal.
		const buttonTextColour = '#000';

		// Call this per form.
		gdprSubscribeModal(formSelector, privacyPolicyURL, linkColour, buttonTextColour);
	}

	// Pops out share modal window
	document.querySelectorAll('.social-share').forEach((element) => {
		element.addEventListener('click', (e) => {

			// Prevents default action
			e.preventDefault();
			// Runs window popup function
			windowPopup($(this).attr("href"), 500, 300);
		});
	});


	// Function for popout window
	function windowPopup(url, width, height) {
		// Calculate the position for the popup so it’s centered on the screen.
		const left = (screen.width / 2) - (width / 2);
		const top = (screen.height / 2) - (height / 2);

		// opens a window with the given url & set position from above
		window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
	}

	const caseStudies = document.querySelector('.case-studies.js-slick');

	if (caseStudies) {
		$(caseStudies).slick({
			arrows: false,
			autoplay: false,
			dots: true,
			infinite: false,
			slidesToScroll: 3,
			slidesToShow: 3,
			speed: 500,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 1,
						draggable: true
					}
				}
			]
		});
	}

	const genericSlick = document.querySelectorAll('.carousel.js-slick');

	if (genericSlick.length > 0) {
		genericSlick.forEach(element => {
			$(element).slick({
				arrows: false,
				autoplay: true,
				centerMode: false,
				autoplaySpeed: 5000,
				dots: true,
				fade: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1
			});	
		});
	}

	const modCenter = document.querySelectorAll('.carousel.js-slick-center');

	if (modCenter.length > 0) {
		modCenter.forEach(element => {
			$(element).slick({
				arrows: true,
				nextArrow: '<img src="assets/images/arrow-right.png">',
				prevArrow: '<img src="assets/images/arrow-left.png">',
				autoplay: false,
				autoplaySpeed: 5000,
				dots: false,
				fade: false,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							nextArrow: '<img src="assets/images/arrow-right-mobile.png">',
							prevArrow: '<img src="assets/images/arrow-left-mobile.png">',
						}
					}
				]
			});
		});
	}

	window.addEventListener('scroll', function() {
		var scroll = window.scrollY || document.documentElement.scrollTop;

		var headerMain = document.querySelector('.header-main');
		if(!headerMain) return;

		if(scroll > 150) {
			headerMain.classList.add('mod-hide');
		} else {
			headerMain.classList.remove('mod-hide');
		}
	});
});